import { createFileRoute } from "@tanstack/react-router";
import { EmailMarketingServicePage } from "./services_.email-marketing";

export const Route = createFileRoute("/services_/email-marketing-services")({
  head: () => ({
    meta: [
      {
        title: "Email Marketing Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "Automated Lifecycle Email Marketing Campaigns.",
      },
    ],
  }),
  component: EmailMarketingServicePage,
});
